// import utils from "@/utils";
// import insider from "./insider";
import Qs from "qs"
import { Ajax } from "../utils/base";
import IP from "../config/config"
// 充值配置接口
export function getPayRechargeConfig (param) {
    const url = IP.mApis() + '/passport/pay/recharge/config';
    return Ajax(url, param, "GET");
}
// 充值下单接口
export function getPayRechargePay (param) {
    const url = IP.mApis() + '/passport/pay/recharge/pay';
    return Ajax(url, Qs.stringify(param, { allowDots: true }), "POST");
    // return Ajax(url, param, "POST");
}
// 红包列表接口
export function getUserCouponList (param) {
    const url = IP.mApis() + '/passport/user/coupon/list';
    return Ajax(url, param, "GET");
}

// 用户信息
export function getUserInfo (param) {
    const url = IP.passportApis() + '/user/info';
    return Ajax(url, param, "POST");
}

// 模型价格列表
export function getPayDataPriceList (param) {
    const url = IP.mApis() + '/passport/pay/data/price-list';
    return Ajax(url, param, "GET");
}
// 模型购买
export function getPayDataBuy (param) {
    const url = IP.mApis() + '/passport/pay/data/buy';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 下单前红包列表
export function getNewsMzUserCouponUseList (param) {
    const url = IP.mApis() + '/passport/user/coupon/use-list';
    return Ajax(url, param, "GET");
}

// 文章购买接口
export function getNewsMzPayNewsBuy (param) {
    const url = IP.mApis() + '/passport/pay/news/buy';
    return Ajax(url, Qs.stringify(param), "POST");
}

// 方案详情
export function getNewsMzPayInfo (param) {
    const url = IP.mApis() + '/news/mz/pay/news/info';
    return Ajax(url, param, "GET");
}

// AI篮球购买信息
export function getAiInfo (param) {
    const url = IP.dcApis() + '/Basketball/getHomeAwayInfo';
    return Ajax(url, param, "GET");
}
// 充值购买红包弹窗逻辑
export function getPayStatus (param) {
    const url = IP.mApis() + '/passport/api/notice/pay-status';
    return Ajax(url, param, "GET");
}
// 结算，检查交易状态
export function getCheckPayStatus (param) {
    const url = IP.passportApis() + '/pay/checkPayStatusByID';
    return Ajax(url, param, "GET");
}
// 充值配置接口
export function getSellPriceList (param) {
    const url = IP.passportApis() + '/SellPrice/getSellPriceList';
    return Ajax(url, param, "GET");
}

// 改名卡信息
export function getRenameCardInfo (param) {
    const url = IP.passportApis() + '/renameCard/info';
    return Ajax(url, param, "POST");
}
// 购买改名卡
export function getRenameCardBuy (param) {
    const url = IP.mApis() + '/passport/pay/rename-card/buy';
    return Ajax(url, Qs.stringify(param), "POST");
}
